import React, {useState, useLayoutEffect} from 'react'
import ReactDOM from 'react-dom'

import { FormControl, InputLabel, Select, OutlinedInput } from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export default function ClinicalSelectionField(props) {
    const [clinicalLabelWidth, setClinicalLabelWidth] = useState(0)

    useLayoutEffect(() => {
        setClinicalLabelWidth(ReactDOM.findDOMNode(props.ClinicalAreaRef.current).offsetWidth)
    }, [props.ClinicalAreaRef])

    const clinicalAreaList = props.clinicalAreas.map(clinical => 
        <option value={clinical.ID} key={clinical.ID}>{clinical.Name}</option>
    )

    return (
        <FormControl variant="outlined" className="input_clinical_area">
            <InputLabel htmlFor="input_clinical_area" 
                ref={props.ClinicalAreaRef} >
                    Select special interest area
            </InputLabel>
            <Select
                native
                IconComponent = {ExpandMoreIcon}
                value={props.selectedClinicalArea}
                onChange={e => props.handleSelectedClinicalArea(e.target.value) }
                input={
                    <OutlinedInput name="input-clinical-area" 
                            labelWidth={clinicalLabelWidth} 
                            id="input_clinical_area" />
                }
            >
                <option value="" />
                {clinicalAreaList}
            </Select>
        </FormControl>
    )
}